<template>
    <div>
        <div class="row">
            <div class="col sau-font sm">
                <div class="widget-payment">
                    <h4>Credit Payment</h4>
                    <div class="sep"></div>
                    <div class="d-flex sau-font-color green sau-font lg" v-if="newPaymentData.total">
                        <div class="mr-auto">Total</div>
                        <div>{{ newPaymentData.total | currency }}</div>
                    </div>
                    <button class="btn btn-lg btn-block btn-success my-4">Add Credit</button>
                    <p class="text-center sau-font xs">By clicking the “Submit Payment” button, you agree to our <a href="#" class="sau-linx green">Terms of Service</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['paymentData'],
    created() {
    },
    data(){
        return{
            newPaymentData: JSON.parse(this.paymentData)
        }
    },
    methods:{
    }
}
</script>
<style>
</style>
